import PatientStub from '../../components/PatientStub.jsx'
export default function PatientOldVersion() { return <PatientStub title="Old version" /> }
